// extracted by mini-css-extract-plugin
export default {"loader":"Router_loader__jj7sB","loaderText":"Router_loaderText__LsW6V"};